import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, Stack, Typography } from "@mui/material";
import { Component } from "react";
import { BsDatabaseGear } from "react-icons/bs";
import MaxContagemInput from "../../ui/MaxContagemInput";
import { httpGet, httpPost } from "../../util/http";

export default class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            changed: false,
            loading: false,
            maxCnt: '',
            locked: false,
            cacheLoading: false,
        }

    }

    componentDidMount() {
        this.refresh();
    }

    cacheClean() {
        this.setState({ cacheLoading: true });
        httpGet('/settings/cacheclean',
            settings => {
                this.setState({
                    cacheLoading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ cacheLoading: false });
            },
        );
    }

    refresh() {
        this.setState({ loading: true });
        httpGet('/settings/read',
            settings => {
                console.log(settings)
                this.setState({
                    maxCnt: settings?.max_cnt,
                    locked: settings?.lock,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    onSubmit(e) {
        e.preventDefault();
        this.setState({
            loading: true,
        });
        httpPost('/settings/save',
            { maxCnt: this.state.maxCnt, lock: this.state.locked },
            () => {
                this.setState({
                    changed: false,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    render() {
        return (
            <form onSubmit={e => this.onSubmit(e)}>
                <Stack>
                    <Accordion>
                        <AccordionSummary>
                            <Typography variant="body2" color="primary"><BsDatabaseGear size={16} /><Box ml={1} component="span"><b>Configurações</b></Box></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box mt={-2} mb={1} borderBottom={1} borderColor="primary.main"></Box>

                            <Typography mt={1} variant="caption" color="primary">Configurações do sistema</Typography>
                            <Stack padding={2} mt={1} gap={1} borderRadius={2} borderColor="#f0fbff">
                                <FormControlLabel
                                    key="lock_invent"
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={this.state.locked}
                                            onChange={e => this.setState({ locked: e.target.checked, changed: true })}
                                        />
                                    }
                                    label={
                                        <Typography variant="caption" fontSize={'13px'}>
                                            Bloquear abertura de inventário semestral.
                                        </Typography>
                                    }
                                />
                                <Box><MaxContagemInput value={this.state.maxCnt} onChange={maxCnt => this.setState({ maxCnt, changed: true })} /></Box>
                                {this.state.changed && <Box>{this.state.loading ? <CircularProgress color="success" size={20} /> : <Button type="submit" size="small" color="btnStyle" variant="contained" disableElevation>Salvar</Button>}</Box>}
                            </Stack>
                            <Stack padding={2} direction="row">
                                <Typography mt={0.8} mr={1} variant="caption">Limpeza do cache de produtos: </Typography>
                                <Box>{this.state.cacheLoading ? <CircularProgress color="success" size={20} /> : <Button onClick={() => this.cacheClean()} size="small" color="btnStyle" variant="contained" disableElevation>Limpar</Button>}</Box>
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                </Stack>
            </form>
        );
    }
}
